import * as React from 'react';
import { Baggage as BaggageRoot } from '../../../../../../CheckoutAdditionalService/components';
import { GdsAggregationServiceBaggage, GdsAggregationServiceGroup } from '../../../../../types';
import { useTranslation } from 'react-i18next';
import { groupGdsSelectedServices } from '../utils';
import { useTheme } from '../../../../../../theme';
import cn from 'classnames';
import { useConfig } from '../../../../../../context';
import { CdnIcon } from '@shared/ui';

interface Props {
	segmentId?: string;
	service?: GdsAggregationServiceGroup;
	hideCard?: boolean;
}

const AggregatedBaggage: React.FC<Props> = ({ segmentId, service, hideCard }) => {
	const { t } = useTranslation('BaggageService');
	const theme = useTheme('Checkout').ServicesAggregationPage;

	const {
		global: {
			servicesAvailable: { animal: animalAvailable }
		}
	} = useConfig();

	const icons = [<CdnIcon icon="Baggage/Musical inst" />];

	if (animalAvailable) {
		icons.push(<CdnIcon icon="Baggage/Pet in cabin" />);
	}

	const selectedServices = groupGdsSelectedServices<GdsAggregationServiceBaggage>(service);

	return (
		<BaggageRoot
			segmentId={segmentId}
			aggregationMode={true}
			totalPrice={service.totalPrice}
			minPrice={service.minPrice}
			isSelected={!!service.selectedServices.length}
			aggregationIcons={icons}
			className={cn({
				[theme.hideServiceCard]: hideCard
			})}
		>
			{selectedServices.map(service => {
				return (
					<div key={service.service.rfics}>
						{service.service.name}, {service.service.value.amount} {t(service.service.value.measurement)} -{' '}
						{service.count} {t('pcs.')}
					</div>
				);
			})}
		</BaggageRoot>
	);
};

export default AggregatedBaggage;
